/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const NormalIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42 43' width='1em' height='1em' {...props}>
			<g data-name='icon normal' transform='translate(-7375 -6143)'>
				<g data-name='Grupo 7460-9'>
					<path
						data-name='Trazado 13530-9'
						d='M7396 6185.472a21.237 21.237 0 1 1 21-21.236 21.119 21.119 0 0 1-21 21.236Zm0-40.982a19.749 19.749 0 1 0 19.534 19.746A19.639 19.639 0 0 0 7396 6144.49Z'
						fill={color}
					/>
				</g>
				<path
					data-name='Trazado 37017'
					d='M7387.956 6160.432a1.94 1.94 0 1 1 1.938 1.932 1.966 1.966 0 0 1-1.938-1.932Z'
					fill={color}
				/>
				<path
					data-name='Trazado 37018'
					d='M7401.069 6160.458a1.931 1.931 0 1 1 1.954 1.906 1.954 1.954 0 0 1-1.954-1.906Z'
					fill={color}
				/>
				<rect
					data-name='Rect\xE1ngulo 84910'
					width={16}
					height={2}
					rx={1}
					transform='translate(7388 6171)'
					fill={color}
				/>
			</g>
		</svg>
	)
}

export default NormalIcon
